/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminAttentionProduct,
    AdminAttentionProductFromJSON,
    AdminAttentionProductFromJSONTyped,
    AdminAttentionProductToJSON,
} from './AdminAttentionProduct';
import {
    AdminMarketplaceCount,
    AdminMarketplaceCountFromJSON,
    AdminMarketplaceCountFromJSONTyped,
    AdminMarketplaceCountToJSON,
} from './AdminMarketplaceCount';

/**
 * 
 * @export
 * @interface AdminAttentionResp
 */
export interface AdminAttentionResp {
    /**
     * 
     * @type {Array<AdminAttentionProduct>}
     * @memberof AdminAttentionResp
     */
    items: Array<AdminAttentionProduct>;
    /**
     * MarketDataUpdatedAt is when the newest eBay market snapshot was captured.
     * @type {string}
     * @memberof AdminAttentionResp
     */
    marketDataUpdatedAt?: string;
    /**
     * MarketplaceCounts counts listings needing attention per marketplace, most first.
     * @type {Array<AdminMarketplaceCount>}
     * @memberof AdminAttentionResp
     */
    marketplaceCounts: Array<AdminMarketplaceCount>;
    /**
     * NoMarketDataProducts are products in sale without market data yet; not in items.
     * @type {number}
     * @memberof AdminAttentionResp
     */
    noMarketDataProducts: number;
}

export function AdminAttentionRespFromJSON(json: any): AdminAttentionResp {
    return AdminAttentionRespFromJSONTyped(json, false);
}

export function AdminAttentionRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminAttentionResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(AdminAttentionProductFromJSON)),
        'marketDataUpdatedAt': !exists(json, 'marketDataUpdatedAt') ? undefined : json['marketDataUpdatedAt'],
        'marketplaceCounts': ((json['marketplaceCounts'] as Array<any>).map(AdminMarketplaceCountFromJSON)),
        'noMarketDataProducts': json['noMarketDataProducts'],
    };
}

export function AdminAttentionRespToJSON(value?: AdminAttentionResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(AdminAttentionProductToJSON)),
        'marketDataUpdatedAt': value.marketDataUpdatedAt,
        'marketplaceCounts': ((value.marketplaceCounts as Array<any>).map(AdminMarketplaceCountToJSON)),
        'noMarketDataProducts': value.noMarketDataProducts,
    };
}

